import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Modal from 'srcReact/components/common2/Modal'
import styles from './styles.module.scss'

function SaveDraftModal({ isOpen, error, closeModal, handleLeave, handleSaveDraft }) {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      handleClose={closeModal}
      title={t('mixrPreview.saveDraft.title')}
      subTitle={t('mixrPreview.saveDraft.subTitle')}>
      <div className={styles.buttons}>
        <Button style='secondary' text={t('global.leave')} handleClick={handleLeave} />
        <Button handleClick={handleSaveDraft} text={t('global.saveDraft')} />
      </div>
      {error && <ErrorMessage className={styles.error} text={error} />}
    </Modal>
  )
}

export default SaveDraftModal
